export const businessUnits = {
  EXPRESS: "EXP",
  DGF: "DGF",
  FREIGHT: "FRE",
  ECS: "ECS",
  PNP: "PNP",
};
